export default function removeEmptyImg(){
    $("img").get().forEach((e) => { 
        if(!$(e).attr('src')) {
            $(e).css('opacity', '0');
            $(e).attr('noSource', true);
        } 
    });
}